import React, { useEffect, useState } from "react";
import CustomerSummaryTable from "../../components/Customer/CustomerSummaryTable";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { Route, Link as RouterLink, Routes, useLocation } from "react-router-dom";
import CustomerHealthChecks from "components/Customer/CustomerHealthChecks";

const CustomersPageMain: React.FC = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");

  const tabs = [
    { name: "Summary", path: "/customers/summary" },
    { name: "Health", path: "/customers/health" },
  ];

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `Customers - ${selectedTabName}`;
  }, [location]);
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Customers
      </Typography>
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>
      <Routes>
        <Route
          path="summary"
          element={<CustomerSummaryTable />}
        />
        <Route
          path="health"
          element={<CustomerHealthChecks />}
        />
        <Route
          path="/"
          element={<CustomerSummaryTable/>}
        />
      </Routes>
    </Box>
  );
};

export default CustomersPageMain;
